import InnerComponent from '@Components/Reports/ReportsList';
import orgContainer from '@Components/AppContainer';

const ReportsList = () => ((orgContainer(InnerComponent)));
export default ReportsList;
